import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import StaticPageReloader from './components/StaticPageReloader';
import { ToxnotReactComponentPaths } from './components/core/ToxnotReactComponentPaths';
import { CreateAndEditSurveyComponentPaths } from './components/Survey/SurveyComponentPaths';
import { EnagementPaths } from './components/Engagement/EngagementPaths';
import { ApplicationState } from './store';
import * as LoginStateController from './store/StateControllers/LoginStateController';
import { AppServices } from './AppServices';
import Engagement from './components/Engagement/Engagement';
import { ToxnotBranded } from './ToxnotBranded';
import { XmlExportComponentPaths } from './components/XmlExport/XmlExportComponentPaths';
import { LoadingSpinner, LoadingSpinnerSize } from './components/core/LoadingSpinner';
import { BulkReportComponentPaths } from './components/BulkReport/BulkReportComponentPath';
import { TaskManagementComponentPaths } from './components/TaskManagement/TaskManagementComponentPaths';

import './custom.css'

type AppProps =
    { appServices: AppServices } &
    typeof LoginStateController.actionCreators;

class App extends React.PureComponent<AppProps> {
    public componentDidMount() {
        this.props.getAppServices();
    }

    // ===============================================================================

    public render() {
        if (!this.props.appServices) {
            // app services not established yet
            
            return (
                <div className="text-center"><LoadingSpinner size={LoadingSpinnerSize.Medium} /></div>
            );
        }

        //
        // app services are established - return full app
        //

        return (
            <Switch>
                <Route path={ToxnotReactComponentPaths.BaseSharedMaterialsPath} component={ToxnotBranded} />
                <Route path={CreateAndEditSurveyComponentPaths.BasePath} component={ToxnotBranded} />
                <Route path={CreateAndEditSurveyComponentPaths.SurveysBasePath} component={ToxnotBranded} />
                <Route path={ToxnotReactComponentPaths.BaseNewsPath} component={ToxnotBranded} />
                <Route path={ToxnotReactComponentPaths.BaseRegulationPath} component={ToxnotBranded} />
                <Route path={ToxnotReactComponentPaths.BaseRegulationDetailsPath} component={ToxnotBranded} />
                <Route exact={true} path={EnagementPaths.EngagePath} component={Engagement} />
                <Route exact={true} path={ToxnotReactComponentPaths.Consult} component={ToxnotBranded} />
                <Route exact={true} path={ToxnotReactComponentPaths.ObtainmentReportsPath} component={ToxnotBranded} />
                <Route path={XmlExportComponentPaths.BasePath} component={ToxnotBranded} />
                <Route path={ToxnotReactComponentPaths.StartPath} component={ToxnotBranded} />
                <Route path={BulkReportComponentPaths.BasePath} component={ToxnotBranded} />
                <Route path={TaskManagementComponentPaths.BasePath} component={ToxnotBranded}/>
                <Route path={ToxnotReactComponentPaths.MyCustomersBasePath} component={ToxnotBranded} />
                <Route path={ToxnotReactComponentPaths.SftpBasePath} component={ToxnotBranded} />
                <Route path={ToxnotReactComponentPaths.BaseAIAssistantPath} component={ToxnotBranded} />
                {/* This catch-all route refreshes the page to re-load the URL from the webserver */}
                <Route component={StaticPageReloader} />
            </Switch>
        );
    }
}

// ===============================================================================

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices}),
    LoginStateController.actionCreators // Selects which action creators are merged into the component's props
)(App as any);
